import type { FC } from 'react';
import Icon from '@utilities/icon';
import type { IconName } from '@utilities/icon';
import Badge from '@com/shared/badge';
import classNames from 'classnames';
import { colors } from '@configs/Theme';

interface BadgeLabelProps {
  text: string;
  iconName: IconName;
  className?: string;
  color?: BadgeColor;
}

type BadgeColor =
  | 'blue'
  | 'gray'
  | 'red'
  | 'green'
  | 'yellow'
  | 'indigo'
  | 'purple'
  | 'pink';

const BadgeLabel: FC<BadgeLabelProps> = ({
  text,
  iconName,
  color = 'yellow',
  className,
}) => {
  return (
    <Badge
      color={color}
      size="sm"
      className={classNames(
        `absolute shadow-fab flex gap-x-[2px] !px-1 !pt-0`,
        className,
      )}
    >
      <Icon name={iconName} fill={colors.yellow['500']} />
      <p className="text-Label/2xSmall text-content-warning">{text}</p>
    </Badge>
  );
};

export default BadgeLabel;
